import { useState, useEffect } from "react";
import axios from "axios";
import { Cpu, Database, Globe, CloudArrowUp, SpinnerGap, Code, Stack } from "@phosphor-icons/react";

import { API_BASE as API } from "../lib/apiBase";

export default function TechStackPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: res } = await axios.get(`${API}/api/admin/tech-stack`, { withCredentials: true });
        setData(res);
      } catch {}
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><SpinnerGap size={32} className="animate-spin text-blue-500" /></div>;

  const sections = [
    { key: "ai_models", title: "Modèles IA", icon: Cpu, color: "text-violet-500" },
    { key: "backend", title: "Backend", icon: Code, color: "text-blue-500" },
    { key: "frontend", title: "Frontend", icon: Globe, color: "text-teal-500" },
    { key: "platform", title: "Plateforme", icon: Stack, color: "text-amber-500" },
    { key: "integrations", title: "Integrations", icon: CloudArrowUp, color: "text-cyan-500" },
    { key: "database_stats", title: "Base de données", icon: Database, color: "text-pink-500" },
  ];

  return (
    <div className="space-y-6 animate-fade-in" data-testid="tech-stack-page">
      <div>
        <h1 className="text-2xl font-bold font-['Outfit']">Stack Technologique</h1>
        <p className="text-sm text-zinc-500 mt-1">Versions et technologies utilisees par KNORIA</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sections.map(({ key, title, icon: Icon, color }) => {
          const entries = data?.[key];
          if (!entries) return null;
          return (
            <div key={key} className="bg-card border border-border rounded-xl overflow-hidden" data-testid={`section-${key}`}>
              <div className="px-5 py-3.5 border-b border-border flex items-center gap-2.5">
                <Icon size={18} className={color} weight="duotone" />
                <h2 className="font-semibold text-sm">{title}</h2>
              </div>
              <div className="divide-y divide-border">
                {Object.entries(entries).map(([k, v]) => (
                  <div key={k} className="px-5 py-2.5 flex items-center justify-between">
                    <span className="text-sm text-zinc-600 dark:text-zinc-400">{k.replace(/_/g, " ")}</span>
                    <span className={`text-sm font-medium ${v === "Active" || v === "active" ? "text-teal-500" : v === "Not configured" ? "text-zinc-400" : ""}`}>
                      {typeof v === "number" ? v.toLocaleString() : String(v)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
